import React from 'react'

import RsvpButton from '../../components/form/RsvpButton'
import ErrorMessage from '../../components/errors/ErrorMessage'
import { type Props as ButtonProps } from '../../components/form/Button'
import { useEvent, useEventRsvp } from './hooks'

interface Props extends ButtonProps { eventId: number }
const ToggleRsvp: React.FC<Props> = ({ eventId, ...rest }) => {
  const { data: eventData, error: eventError, isLoading } = useEvent(eventId)
  const { trigger: triggerRsvp, isMutating, error: errorRsvp } = useEventRsvp(eventId)

  if(errorRsvp || eventError) {
    return <ErrorMessage message={errorRsvp?.message || eventError?.message} />
  }

  const handleClick = async () => {
    await triggerRsvp({ eventId, rsvpStatus: !eventData?.rsvpStatus })
  }
  const isPastEvent = new Date(eventData?.endDate ?? '') < new Date()
  return (
    <RsvpButton attending={!!eventData?.rsvpStatus} onClick={handleClick} disabled={isPastEvent || isMutating || isLoading} {...rest} />
  )
}

export default ToggleRsvp
